export const mergeStyles = (...args: any[]): Record<string, string>[] => {
  const mergedStyles = args.reduce((acc, style) => {
    if (typeof style === 'undefined' || style === null || typeof style === 'boolean' || typeof style !== 'object') {
      return acc;
    } else if (Array.isArray(style)) {
      return [...acc, ...style.filter(style => !!style)];
    } else {
      return [...acc, style];
    }
  }, []);

  return mergedStyles;
};
